import axios from "@/plugins/axios-setting";

export function getBackendVersion(): Promise<string> {
  return axios.get("/api/version/");
}
